import { BlobContainerType } from "src/app/core/admin-panel/models/BlobContainerType.enum";
import { BulkConfigurationType } from "src/app/core/admin-panel/models/BulkConfigurationType.enum";
import { TemplateType } from "src/app/shared/Models/enums/TemplateType.enum";

export const APIEndpoints = {
  getSurvey: "/OutsideSurvey/survey/", // + {surveyId}
  getInsideSurvey: "/InsideSurvey/", // + {surveyId}
  getInsideSurveyLayoutUrl: (id: string) =>
    `/InsideSurvey/GetLayoutPhoto/${id}`, // + {surveyId}
  authenticateUrl: "/Account/Authenticate", // hTTPPost
  addUserUrl: "/Command/CreateUser", // hTTPPost
  deleteUserUrl: "/Command/DeleteUser/", // hTTPPost
  updateUserUrl: "/Command/UpdateUser", // hTTPost
  getAccountUrl: "/Account/Users/", // hTTPGet + {id}
  getAllUsersUrl: "/Account/Users/All", // hTPPGet
  getUsersByRole: "/Account/Users/ByRoleName", // hTPPGet
  getAllRoles: "/Account/Roles/All", // hTTPGet
  getRole: "/Account/Roles/", // hTTPGet + {id}
  getBuildingSurveyList: "/Building/SurveyList/All", // hTTPGet
  getCommandTypeList: "/CommandDescriptor/GetCommandTypes", // hTTPGet
  getExportFieldList: "/ExportFields/Export/GetAllFields", // hTTPGet
  getAdressFilterList: "/Building/SurveyList/Filters/City", // hTTPGet
  createBuilding: "/Command/CreateBuilding", // httpPost
  changeBuildingAddress: "/Command/ChangeBuildingAddress", // httpPost
  deleteSurvey: "/Command/DeleteSurvey", // httpGet + {id}
  surveyListAddressFilter: "/Building/SurveyList/Filters/Address", // httpGet
  surveyListFiberHoodFilter: "/Building/SurveyList/Filters/FiberHood/", // httpGet + {cityName}
  getNewBuildingFilterAreaId: "/Building/SurveyList/Filters/NewBuilding", // httpGet + {areaId}
  getAreasByParentId: "/Building/SurveyList/Areas/", // httpGet + {parentId}
  addBuildingRangeToBuildingGroup: "/Command/AddBuildingRangeToBuildingGroup", // httpPost
  getTempBuildingGroupName: "/Building/TempBuildingGroupName", // httpGet + ?areaId={areaId}&buildingIds={buildingIds}
  addBuildingRangeToNewBuildingGroup:
    "/Command/AddBuildingRangeToNewBuildingGroup", // httpPost
  changeNameBuildingGroup: "/Command/ChangeNameBuildingGroup", // httpPost
  changeUnitInfo: "/Command/ChangeUnitInfo", // httpPost
  updateMainAddress: "/Command/UpdateMainAddress", // httpPost
  changeOutsideSurveyEngineer: "/Command/ChangeEngineer",
  reassignOutsideSurveyEngineer: "/Command/ReassignOutsideSurvey", // httpPost
  reassignInsideSurveyEngineer: "/Command/ReassignInsideSurvey", // httpPost
  backSurveyToOutsideOngoing: "/Command/InsideSurveyBackToOutsideOngoing",
  createInsideSurvey: "/Command/CreateInsideSurvey",
  createOutsideSurveyEngineer: "/Command/CreateOutsideSurvey",
  updateOutsideSurveyEngineer: "/Command/UpdateOutsideSurvey",
  changeOutsideSurveyPhotoRemarks: "/Command/ChangeOutsideSurveyPhotoRemarks",
  addPhotoToOutsideSurvey: "/Command/AddPhotoToOutsideSurvey",
  removePhotoToOutsideSurvey: "/Command/RemovePhotoToOutsideSurvey",
  removeAllPhotoPointsByOutsideSurveyPhotoId:
    "/Command/RemoveAllPhotoPointsByOutsideSurveyPhotoId",
  addPhotoToInsideSurvey: "/Command/AddPhotoToInsideSurvey", // httpPost
  removePhotoToInsideSurvey: "/Command/RemovePhotoToInsideSurvey", // httpPost
  changeInsideSurveyPhotoRemarks: "/Command/ChangeInsideSurveyPhotoRemarks", // httpPost
  removeAllPhotoPointsByInsideSurveyPhotoId:
    "/Command/RemoveAllPhotoPointsByInsideSurveyPhotoId", // httpPost
  updateSurvey: "/Command/UpdateSurvey", // httpPost
  changeEngineer: "/Command/ChangeEngineer", // httpPost
  getBuildingListByAreaId: "/Building/SurveyList/ByArea/", // httpGet + {areaId}
  removePersonFromBuilding: "/Command/RemovePersonFromBuilding", // httpPost
  triggerCSV: "/Command/TriggerCSV", // httpPost
  exportSurvey: "/Report/ExportSurvey", // httpPost
  exportBuildingAction: "/Report/ExportBuildingActions", // httpPost
  unlockUser: "/Command/Users/Unlock",
  exportCSV: "/Building/Buildings/ExportCSV",
  findAllBuildingGroupsByAreaId:
    "/BuildingGroup/FindAllBuildingGroupsByAreaId/", // + {areaId}
  getBuildingsByBuildingGroupId: "/Building/Buildings/ByBuildingGroup/",
  removeGroupFromBuilding: "/Command/RemoveGroupFromBuildings",
  getContactInfo: "/OutsideSurvey/contact-info/", // + {query},
  updatePerson: "/Command/UpdatePerson",
  addExistingPersonToBuilding: "/Command/AddExistingPersonToBuilding", // httpPost
  addNewPersonToBuilding: "/Command/AddNewPersonToBuilding", // httpPost
  completeSurvey: "/Command/CompleteSurvey", // httpPost
  completeInsideSurvey: "/Command/CompleteInsideSurvey", // httpPost
  validateSurvey: "/Command/ValidateSurvey", // httpPost
  saveValidateSurvey: "/Command/SaveValidationOutsideSurvey", // httpPost
  rejectSurvey: "/Command/RejectSurvey", // httpPost
  getAllAddressesWithoutABuilding:
    "/Building/SurveyList/Building/GetAllAddressesWithoutABuildingByAreaId", // hTTPGet + {areaId}
  getAllFiberhoodAddressesByAreaId:
    "/Building/SurveyList/Building/GetAllFiberhoodAddressesByAreaId", // hTTPGet + {areaId}
  createBuildingWithExistingAddress:
    "/Command/CreateBuildingWithExistingAddress", // hTTPPost
  changeInsideUnitInfo: "/Command/ChangeInsideUnitInfo", // hTTPPost
  updateInsideSurveyBuildingLayout: "/Command/UpdateInsideSurveyBuildingLayout",
  saveValidateInsideSurvey: "/Command/SaveValidationInsideSurvey",
  validateInsideSurvey: "/Command/ValidateInsideSurvey",
  rejectInsideSurvey: "/Command/RejectInsideSurvey",
  deleteInsideUnit: "/Command/DeleteInsideUnit", // hTTPPost
  createUnitWithPerson: "/Command/CreateUnitWithPerson", // hTTPPost,
  templateList: "/Templates",
  latestTemplates: "/Templates/latest",
  templateByGroupAndVersion: (type: TemplateType, version: number) =>
    `/Templates/${type}/${version}`,
  createTemplate: "/Command/CreateTemplate",
  deleteTemplate: "/Command/DeleteTemplate",
  uploadTemplate: "/Command/UploadTemplate",
  updateInsideSurveyTechnicalInfo: "/Command/UpdateInsideSurveyTechnicalInfo", // hTTPPost
  getDocumentListItems: "/DocumentList/ByAreaId", // + {areaId}
  updateDocumentContact: "/Command/UpdateDocumentContact", // hTTPPost
  deleteAddress: "/Command/DeleteAddress", // hTTPPost
  assignAddressToNewBuilding: "/Command/AssignAddressToNewBuilding", // hTTPPost
  assignAddresToExistingBuilding: "/Command/AssignAddressToExistingBuilding", // hTTPPost
  getLomBuildingsByAddressCriteria: "/Building/GetLomBuildingsByCriteria", // hTTPPost
  uploadFloorPlan: "/Command/UploadFloorPlan",
  auditLogs: (id: string) => `/Audit/${id}`,
  commandLogs: (id: string) => `/Audit/CommandLogs/${id}`,
  commandDetails: (id: string) => `/CommandDescriptor/CommandDetails/${id}`,
  removeIntroPhoto: "/Command/RemoveIntroPhoto", // httpPost
  addIntroPhoto: "/Command/AddIntroPhoto", // httpPost
  changeOutsideUnitInfoFromInsideSurvey:
    "/Command/ChangeOutsideUnitInfoFromInsideSurvey",
  changeInsideUnitInfoFromInsideSurvey: "/Command/Changebuildingfloors",
  changeBuildingType: "/Command/ChangeBuildingType",
  getCityContacts: "/Building/CityList/Contacts",
  upsertCityContact: "/Command/UpsertCityContact",
  uploadBuildingDocumentPhoto: "/Command/UploadBuildingDocumentPhoto",
  getInsideUnits: (id: string) => "/InsideSurvey/GetInsideUnits/" + id,
  getDocumentByBuildingId: "/DocumentList/ByBuildingId", // + {areaId}
  printDocument: "/Command/MarkDocumentAsPrinted", // + {areaId}
  addGeneralRemarkToDocument: "/Command/AddGeneralRemarkToDocument", // + {areaId}
  approveDocument: "/Command/ApproveDocument", // + {areaId}
  deleteTsa: "/Command/DeleteTsa", // + {areaId}
  rejectDocument: "/Command/RejectDocument", // + {areaId}
  rejectSignedDocument: "/Command/RejectSignedDocument", // + {areaId}
  sendBackToPrinted: "/Command/SendBackToPrinted", // + {areaId}
  sendBackToPending: "/Command/SendBackToPending", // + {areaId}
  changeInsideSurveyPhotoIndex: "/Command/ChangeInsideSurveyPhotoIndex",
  changeOutsideSurveyPhotoIndex: "/Command/ChangeOutsideSurveyPhotoIndex",
  createSSRDocument: "/Command/CreateSSRDocument", // hTTPPost
  triggerInitialLoad: "/Command/TriggerInitialLoad", // hTTPPost
  setInsideSurveyTsaNoAdmin: "/Command/SetInsideSurveyTsaNoAdmin", // hTTPPost
  verifyMftConnection: "/Command/VerifyMftConnection",
  verifyB2BConnection: "/Command/VerifyB2BServiceConnection",
  search: "/Search",
  changeBlockForBuildings: "/Command/ChangeBlockForBuildings",
  getAreaContactList: "/Area/FindAllAreasContacts", // hTTPGet
  changeAreaContact: "/Command/ChangeAreaContact", // hTTPPost
  deleteAreaContact: "/Command/DeleteAreaContact", // hTTPPost
  retryCommand: "/CommandHandlingAttempts/Retry",
  restartCommand: "/CommandHandlingAttempts/Restart",
  getExportFields: "/ExportFields/GetAllExportFields",
  changeExportField: "/Command/ChangeExportField",
  getBulkConfigurationSettings:
    "/BulkConfiguration/GetAllBulkConfigurationSettings",
  getBulkConfigurationSettingsForCurrentUser:
    "/BulkConfiguration/GetAllBulkConfigurationsForCurrentUser",
  changeBulkConfigurationSetting: "/Command/ChangeBulkConfigurationSetting",
  getBulkConfigurations: "/BulkConfiguration/GetAllBulkConfigurations",
  getAllBulkBlobs: "/BulkBlobStorage/GetAllBulkBlobs",
  getAllBulkBlobsForConfigurationType: (type: string) =>
    `/BulkBlobStorage/GetAllBulkBlobs/${type}`,
  getDownloadLink: (containerType: BlobContainerType, fileName: string) =>
    `/BulkBlobStorage/GetDownloadLink/${containerType.toString()}/${fileName}`,
  uploadBulkBlobFile: "/Command/UploadBulkBlobFile",
  lomImportBuilding: "/Command/LomImport/Building",
  lomImportAddress: "/Command/LomImport/Address",
  getBulkSample: (type: number) => `/BulkConfiguration/BulkSample/${type}`,
  getNetworkOwners: "/Templates/networkOwners",
  IsDefaultArea: (id: string) => `/DocumentList/IsDefaultArea/${id}`,
  refreshBuilding: "/Command/BuildingRefresh",
  getEmptyBuildings: "/Building/EmptyBuildings",
  getGeneralSettings: "/Settings/GetAllGeneralSettings",
  changeGeneralSetting: "/Settings/ChangeGeneralSetting",
  uploadInitialLoadBlobFile: "/Command/UploadInitialLoadBlobFile",
  getmaintenancemessage: "/MaintenanceMessages/GetMaintenanceMessage",
  addmaintenancemessage: "/MaintenanceMessages/AddMaintenanceMessage"
};
